(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bo-collection"] && !Shopify.designMode) return;
  try {
    
  // BO 27-10-2026 — filters zonder herladen: klik op een filter haalt enkel deze sectie opnieuw op
  // (Section Rendering API), zodat de pagina, open filtergroepen en de scrollpositie van de lijsten blijven staan.
  (function(){
    var LINKS = '.bo-col__side-fx-value, .bo-col__tf-value, .bo-col__sf-value, .bo-col__chip, .bo-col__active-chip, .bo-col__active-clear, .bo-col__pstep';
    var LISTS = '.bo-col__side-fx-list, .bo-col__sf-list, .bo-col__tf-panel, .bo-col__drawer-panel, .bo-col__drawer-body';
    var busy = false;
    try { history.scrollRestoration = 'manual'; } catch(_) {}
    try { sessionStorage.removeItem('boColScrollY'); } catch(_) {}

    function keyOf(el){
      var d = el.closest('details'), t = '';
      var s = d && d.querySelector('summary');
      if (s) s.childNodes.forEach(function(n){ if (n.nodeType === 3 || (n.nodeType === 1 && !/badge/.test(n.className))) t += n.textContent; });
      return (d ? d.className : '') + '|' + t.trim() + '|' + String(el.className).replace(/\bis-[\w-]+/g, '').trim();
    }
    function snapshot(root){
      var st = { open: {}, scroll: {}, drawer: null };
      root.querySelectorAll('details').forEach(function(d){ st.open[keyOf(d)] = d.open; });
      root.querySelectorAll(LISTS).forEach(function(l){ if (l.scrollTop) st.scroll[keyOf(l)] = l.scrollTop; });
      var dr = root.querySelector('#bo-col-drawer');
      if (dr) st.drawer = dr.hidden;
      return st;
    }
    function restore(root, st){
      root.querySelectorAll('details').forEach(function(d){ var k = keyOf(d); if (k in st.open) d.open = st.open[k]; });
      root.querySelectorAll(LISTS).forEach(function(l){ var k = keyOf(l); if (st.scroll[k]) l.scrollTop = st.scroll[k]; });
      var dr = root.querySelector('#bo-col-drawer');
      if (dr && st.drawer !== null) dr.hidden = st.drawer;
    }
    function scroller(){
      var pw = document.querySelector('.page-wrapper');
      if (pw && /auto|scroll/.test(getComputedStyle(pw).overflowY)) return pw;
      return document.scrollingElement || document.documentElement;
    }
    function nameOf(a){ var n = a.querySelector('[class$="-name"]'); return keyOf(a) + '|' + (n ? n.textContent : a.textContent).trim(); }
    // houd de aangeklikte filter op dezelfde plek op het scherm, ook als de lijsten erboven korter/langer worden
    function keepInPlace(root, anchor){
      if (!anchor) return;
      var match = null;
      root.querySelectorAll(LINKS).forEach(function(a){ if (!match && nameOf(a) === anchor.key && a.offsetParent) match = a; });
      if (!match) return;
      var delta = match.getBoundingClientRect().top - anchor.top;
      if (Math.abs(delta) < 1) return;
      var sc = scroller(), prev = sc.style.scrollBehavior;
      sc.style.scrollBehavior = 'auto';
      sc.scrollTop += delta;
      sc.style.scrollBehavior = prev;
    }
    function load(href, push, clicked){
      var sec = document.querySelector('section.bo-col');
      var wrap = sec && sec.closest('.shopify-section');
      if (!sec || !wrap) { window.location.href = href; return; }
      var sid = wrap.id.replace('shopify-section-', '');
      var u = new URL(href, window.location.origin);
      u.searchParams.set('section_id', sid);
      busy = true;
      sec.classList.add('is-loading');
      fetch(u.toString(), { headers: { 'Accept': 'text/html' } })
        .then(function(r){ if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function(html){
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('section.bo-col');
          if (!fresh) throw new Error('no section');
          var st = snapshot(sec);
          var anchor = (clicked && clicked.isConnected) ? { key: nameOf(clicked), top: clicked.getBoundingClientRect().top } : null;
          sec.replaceWith(fresh);
          restore(fresh, st);
          if (push) history.pushState({ boCol: true }, '', href);
          window.dispatchEvent(new Event('resize'));
          document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { sectionId: sid } }));
          keepInPlace(fresh, anchor);
        })
        .catch(function(){ window.location.href = href; })
        .then(function(){ busy = false; var s = document.querySelector('section.bo-col'); if (s) s.classList.remove('is-loading'); });
    }
    document.addEventListener('click', function(e){
      var a = e.target.closest(LINKS);
      if (!a || !a.closest('section.bo-col')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      e.preventDefault();
      if (busy) return;
      load(href, true, a);
    });
    window.addEventListener('popstate', function(){
      if (document.querySelector('section.bo-col')) load(window.location.href, false);
    });
  })();
  // Close top-filter dropdowns on outside click
  document.addEventListener('click', function(e){
    var opens = document.querySelectorAll('[data-bo-topfilters] details[open]');
    opens.forEach(function(d){ if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  // "Toon meer producten" — fetch next page, append its grid cards, update button URL
  document.addEventListener('click', async function(e){
    var btn = e.target.closest('[data-bo-loadmore]');
    if (!btn) return;
    var url = btn.dataset.nextUrl;
    if (!url) return;
    btn.classList.add('is-loading');
    btn.disabled = true;
    try {
      var res = await fetch(url, { headers: { 'Accept': 'text/html' } });
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-bo-grid]');
      var newBtn  = doc.querySelector('[data-bo-loadmore]');
      var grid    = document.querySelector('[data-bo-grid]');
      if (newGrid && grid) {
        var frag = document.createDocumentFragment();
        Array.from(newGrid.children).forEach(function(node){ frag.appendChild(node); });
        grid.appendChild(frag);
      }
      if (newBtn) {
        btn.dataset.nextUrl = newBtn.dataset.nextUrl;
        var cnt = doc.querySelector('[data-bo-count]');
        var localCnt = document.querySelector('[data-bo-count]');
        if (cnt && localCnt) localCnt.innerHTML = cnt.innerHTML;
      } else {
        var wrap = btn.closest('[data-bo-loadmore-wrap]');
        if (wrap) wrap.innerHTML = '<p class="bo-col__loadmore-count">U hebt alle artikelen bekeken.</p>';
      }
    } catch (err) {
      console.error('load-more failed', err);
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
    btn.classList.remove('is-loading');
    btn.disabled = false;
  });
  // Open/close "Alle filters" drawer
  document.addEventListener('click', function(e){
    var openBtn = e.target.closest('[data-bo-openall]');
    var closeBtn = e.target.closest('[data-bo-closeall]');
    var drawer = document.getElementById('bo-col-drawer');
    if (!drawer) return;
    if (openBtn) { drawer.hidden = false; document.body.style.overflow = 'hidden'; }
    else if (closeBtn || (e.target === drawer && !drawer.hidden)) { drawer.hidden = true; document.body.style.overflow = ''; }
  });
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Escape') return;
    var drawer = document.getElementById('bo-col-drawer');
    if (drawer && !drawer.hidden) { drawer.hidden = true; document.body.style.overflow = ''; }
  });
  // Sticky mobiele balk — "Sorteren" opent de bestaande sorteer-select
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-bo-focus-sort]');
    if (!b) return;
    var sel = document.getElementById('bo-sort');
    if (!sel) return;
    try { sel.focus(); sel.click(); } catch (err) {}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bo-existing-customer"] && !Shopify.designMode) return;
  try {
    
  // If the URL has ?u=<id> or ?uuid=<id>, surface a small "we recognized you" note
  (function(){
    var qs = new URLSearchParams(window.location.search);
    var id = qs.get('u') || qs.get('uuid') || qs.get('contact');
    if (!id) return;
    var note = document.querySelector('[data-bo-ec-uuidnote]');
    var key  = document.querySelector('[data-bo-ec-uuidkey]');
    if (note && key) {
      key.textContent = id.slice(0, 8) + (id.length > 8 ? '…' : '');
      note.style.display = 'flex';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
